export default __webpack_public_path__ + "static/media/MaterialMetal_07.cbf00d7c.png";